import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_PACKS = `${API_URL}/adminWeb/topup-packs`
const DELETE_PACK = `${API_URL}/adminWeb/topup-pack/`
const ADD_PACK = `${API_URL}/adminWeb/topup-pack`
const UPDATE_PACK = `${API_URL}/adminWeb/topup-pack/`
export const getTopupPacks = createAsyncThunk(
  "getTopupPacks",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_PACKS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateTopupPack = createAsyncThunk(
  "updateTopupPack",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${UPDATE_PACK}${values.id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getTopupPacks({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addTopupPack = createAsyncThunk(
  "addTopupPack",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${ADD_PACK}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getTopupPacks({ page: values.selectedPage || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTopupPack = createAsyncThunk(
  "deleteTopupPack",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${DELETE_PACK}${values.id}`);
      notify(data.responseMessage, 'success');
      dispatch(getTopupPacks({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);
